import type { ThemeConfig } from 'antd';
import { theme } from 'antd';

export const themeConfig: ThemeConfig = {
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary: '#1d39c4',
    colorInfo: '#1d39c4',
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    borderRadius: 6
  },
  components: {
    Layout: {
      headerBg: '#ffffff',
      bodyBg: '#f7f9fc',
      siderBg: '#f8f9fb',
      headerHeight: 60
    },
    Menu: {
      itemSelectedColor: '#1d39c4',
      itemSelectedBg: '#e9edfb'
    },
    Button: {
      controlHeight: 38,
      borderRadius: 6
    }
  }
};
